export enum TableGridType {
  Unknown,
  List,
  RelatedList,
  CustomRelatedList
}
